import { g } from '@pretto/bricks/components/layout'
import Link from '@pretto/bricks/website/utility/Link'

import styled, { css, keyframes } from 'styled-components'

const dash = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`
const needleAnimation = angle => keyframes`
  to {
    transform: rotateZ(${angle}deg);
  }
`
const getPathColor = ({ $percentage, theme: { colors } }) => {
  if ($percentage <= 10) {
    return colors.accent2
  }
  if ($percentage <= 30) {
    return colors.accent3
  }
  if ($percentage <= 50) {
    return colors.neutral4
  }
  if ($percentage <= 70) {
    return colors.primary4
  }
  return colors.primary3
}
export const Indicator = styled.div`
  color: ${({ theme }) => theme.colors.white};
`
export const TooltipLink = styled(Link)`
  text-decoration: underline;
`
export const SvgContainer = styled.div`
  position: relative;
  margin-top: ${g(2)};

  ${({ width, height, $strokeWidth }) =>
    css`
      width: ${width}px;
      height: ${height}px;

      &::after {
        position: absolute;
        content: '';
        width: ${$strokeWidth}px;
        height: ${$strokeWidth}px;
        border-radius: 50%;
        left: 0;
        bottom: 0;
        background-color: ${getPathColor};
      }
    `}
`
export const Svg = styled.svg``
export const FullPath = styled.path`
  stroke: ${({ theme }) => theme.colors.primary2};
`
export const Path = styled.path`
  stroke: ${getPathColor};
  animation: ${dash} 1s ease-in-out forwards;

  ${({ $pathLength }) =>
    css`
      stroke-dasharray: ${$pathLength};
      stroke-dashoffset: ${$pathLength};
    `}
`
export const Needle = styled.svg`
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 2;

  ${({ $rotationAngle, $strokeWidth, height }) =>
    css`
      left: -${$strokeWidth}px;
      right: -${$strokeWidth}px;
      animation: ${needleAnimation($rotationAngle)} 1s ease-in-out forwards;
      transform-origin: 50% ${height - $strokeWidth}px;
    `}
`
export const NeedlePath = styled.path`
  stroke: ${({ theme }) => theme.colors.white};
`
